/*
 * This file contains a utility function fetchData that asynchronously fetches data from a given URL.
 * It prepends the URL with the REACT_APP_API_URL environment variable and handles errors by logging them to the console.
 * The function returns a promise that resolves to the fetched data.
 */

const fetchData = (url) => {
  const fetchDataResponse = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
        cache: 'no-store'
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  return fetchDataResponse();
};

export default fetchData;
